import { IApiOfficeholder, IOfficeholder } from './types';

const formatOfficeholder = ({
  division,
  family_name: familyName,
  given_name: givenName,
  ...rest
}: IApiOfficeholder): IOfficeholder => ({
  ...rest,
  district: division,
  familyName,
  givenName,
});

export default formatOfficeholder;
